import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import TabNavigation from "Components/common/TabNavigation";
import ImportsRouting from "./ImportsRouting";
// import ProcessingLoader from "Components/common/ProcessingLoader";

const Imports = observer(props => {
  const location = useLocation();

  const IMPORT_MANAGEMENT_TABS = [
    {
      id: "csv",
      name: "CSV",
      path: "csv"
    },
    {
      id: "linkedin",
      name: "LinkedIn",
      path: "linkedin"
    },
    {
      id: "exports",
      name: "Exports",
      path: "exports"
    },
    {
      id: "enrich",
      name: "Enrich",
      path: "enrich"
    }
  ];

  return (
    <>
      <TabNavigation
        tabList={IMPORT_MANAGEMENT_TABS}
        className="importsNavigation"
      />
      <ImportsRouting {...props} />
    </>
  );
});

export { Imports };
export default Imports;
